import { CALL_API } from '../middleware';
import {
    GET_DEPOID,
    GET_DEPOID_SUCCESS,
    SUBMIT_DEPOID,
    SUBMIT_DEPOID_SUCCESS,
} from '../types/links';

export const getDepoIds = async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/user/getDepoIds',
                method: 'POST',
                types: [GET_DEPOID_SUCCESS, GET_DEPOID],
                // enableFixture: true,
                json: `depoIds.json`,
            },
        });
    } catch (err: any) {
        throw err;
    }
};

export const submitDepoRequest = (body: SubmitDepoRequestBody) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/user/submitDepoServiceRequest',
                method: 'POST',
                types: [SUBMIT_DEPOID_SUCCESS, SUBMIT_DEPOID],
                body,
                // enableFixture: true,
                json: `depoRequest.json`,
            },
        });
    } catch (err: any) {
        throw err;
    }
};
